import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const deleteUser = (id: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: `${getUrl(APIEndPoints.deleteUser)}?id=${+id}`,
    method: 'DELETE',
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { deleteUser }
